import { pick, values } from "lodash";

import { MENUITEMS } from "./StringConstants";

declare global {
  interface Window {
    appConfig: {
      apiURL: string;
      apiBase: string;
      inactivityTimeout: string;
      logoutTimeout: string;
      menusEnabled: string;
      defaultRedirect: string;
      authflow: string;
      flowType: string;
      allowedDomains: string;
    };
  }
}

const appConfig = window.appConfig as any;

const decodeBase64 = (value?: string): string => {
  try {
    return value ? atob(value) : "";
  } catch (e) {
    console.error("Invalid base64 string for azureClientId", e);
    return "";
  }
};

export const currencyCode = appConfig.currencyCode || "",
  multiCloudCurrencyCode = appConfig.currencyCodeMultiCloud || "",
  logoutTimout = appConfig.logoutTimeout,
  refreshTokenTime = appConfig.refreshTime,
  inaAcitvityTimeout = appConfig.inactivityTimeout,
  stripeDomain = appConfig.stripeDomain || "",
  stripeSecret = appConfig.stripeKey || "",
  apiURL = appConfig.apiURL || "",
  basePath = appConfig.apiBase || "api",
  orgName = appConfig.orgName,
  supportEmail = appConfig.supportEmail,
  mediaHost = appConfig.mediaHost,
  defaultRedirect = appConfig.defaultRedirect || "",
  stripeEnabled = appConfig.stripeEnabled === "true" || false,
  azureTenantId = decodeBase64(appConfig.azureADTenantID || ""),
  azureClientId = decodeBase64(appConfig.azureADClientID || ""),
  reactAuthFlow = appConfig.authflow || "Interna",
  flowType = appConfig.flowType || "PCD",
  allowedDomains = appConfig.allowedDomains || "",
  magpHost = appConfig.magpHost || "",
  magpApiURL = appConfig.magpApiURL || "",
  eramanHost = appConfig.eramanHost || "",
  magpWebsiteUrl = appConfig.magpWebsiteUrl || "",
  passengerWebsiteUrl = appConfig.passengerWebsiteUrl || "",
  passengerHost = appConfig.passengerHost || "",
  passengerApiUrl = appConfig.passengerApiUrl || "",
  eramanApiURL = appConfig.eramanApiURL || "",
  corporateApiUrl = appConfig.corporateApiUrl || "",
  corporateHost = appConfig.corporateHost || "",
  eramanWebsiteUrl = appConfig.eramanWebsiteUrl || "",
  corporateWebsiteUrl = appConfig.corporateWebsiteUrl || "",
  centralizedHost = appConfig.centralizedHost || "",
  centralizedSasToken = appConfig.sasToken || ",";

export const xApiKey =
  window.location.hostname === "digitalecms.malaysiaairports.com.my" ||
  (apiURL && apiURL.includes("api.myairports.com.my") && !apiURL.includes("sit") && !apiURL.includes("nprod") && !apiURL.includes("dev"))
    ? "f02f252a781a4db584d1ae9fce22bed1"
    : "168e77d2c94c4813912366ded358f904";

export const allowedDomainsAll = allowedDomains.split(",");

let menuItems = appConfig.menusEnabled;
// let user = JSON.parse(localStorage.getItem("user") || "{}");
// if (user && user.role == "CLM_USER") {
//   menuItems = "CLM";
// }
const itemsfromEnv = menuItems?.split(",") as Array<string>;

export enum UserType {
  PCD_USER = "pcd",
  COMMERCIAL_USER = "commercial",
  CMU_CREATOR = "commercial",
  CMU_REVIEWER = "commercial",
  LOO_CREATOR = "commercial",
  LOO_REVIEWER = "commercial",
  TA_REVIEWER = "commercial",
  CLM_USERS = "clm",
  LOA_CREATOR = "pcd",
  LOA_REVIEWER = "pcd",
  CONTRACT_CREATOR = "pcd",
  CONTRACT_REVIEWER = "pcd",
  PCD_ADMIN = "pcd",
  COMMERCIAL_ADMIN = "commercial",
  SUPER_ADMIN = "clm",
  LEGAL_USER = "legal",
  LEGAL_ADMIN = "legal",
}

export enum recipientType {
  SIGNER = "Signer",
  CVEF_SIGNER = "CVEF_Signer",
  VENDOR = "Vendor",
  STAMPER = "Stamper",
  LHDN_STAMPER = "LHDN_Stamper",
  TENANT = "Tenant",
}

export const enabledMenuItems = values(pick(MENUITEMS, itemsfromEnv));
